/**
 * Public blog API client. No auth – these endpoints are open to anyone.
 */

export interface BlogListItem {
  slug: string;
  title: string;
  excerpt: string | null;
  coverImageUrl: string | null;
  author: string;
  publishedAt: string;
}

export interface BlogPostDetail {
  slug: string;
  title: string;
  excerpt: string | null;
  author: string;
  coverImageUrl: string | null;
  publishedAt: string;
  /** Server-rendered HTML (Markdown → safe HTML via DOMPurify). */
  html: string;
}

export const blogApi = {
  async list(): Promise<{ items: BlogListItem[] }> {
    const r = await fetch('/api/blog');
    if (!r.ok) throw new Error(`Failed (${r.status})`);
    return r.json();
  },
  async get(slug: string): Promise<BlogPostDetail> {
    const r = await fetch(`/api/blog/${encodeURIComponent(slug)}`);
    if (!r.ok) {
      const e = await r.json().catch(() => ({}));
      throw new Error(e?.error || `Failed (${r.status})`);
    }
    return r.json();
  },
};
